/* ═══════════════════════════════════════════════════════════════
   taskUrlLink — parses the task deep link the server's assignment email
   points at (ec2-api/task-permissions.js `taskLink`:
   `https://specforma.app/?view=tasks&taskId=<id>`). Pure, no DOM —
   app.tsx calls this against `window.location.search` after auth is
   established, then strips the params with history.replaceState.
   ═══════════════════════════════════════════════════════════════ */

/** Bounded length + id charset (the renderer's own generated ids are
 *  `task-<base36><base36>`; a server-issued id may be a plain uuid) —
 *  never trusts an arbitrary query value into app state unchecked. */
const TASK_ID_RE = /^[A-Za-z0-9_-]{1,100}$/;

export interface TaskUrlLink {
  taskId: string;
}

/** Returns null when the link isn't a `view=tasks` task link, or when
 *  `taskId` fails validation — never throws on a malformed/missing param. */
export function parseTaskUrlLink(search: string): TaskUrlLink | null {
  let params: URLSearchParams;
  try {
    params = new URLSearchParams(search);
  } catch {
    return null;
  }
  if (params.get('view') !== 'tasks') return null;
  const taskId = params.get('taskId');
  if (!taskId || !TASK_ID_RE.test(taskId)) return null;
  return { taskId };
}
